var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useRef, useState, useEffect } from 'react';
import { DrawerContainer, DrawerHandle, DrawerCard, DrawerTitle, DrawerFooter, DrawerContent, DrawerImage, DrawerOverflow, DrawerCloseButton, DrawerBackdrop, DrawerFooterBorder, } from './elements';
import noop from '../../util/noop';
import useDrawerBehavior from './useDrawerBehavior';
export var Drawer = React.forwardRef(function (_a, fRef) {
    var open = _a.open, title = _a.title, imgSrc = _a.imgSrc, footer = _a.footer, children = _a.children, _b = _a.onOpenUpdate, onOpenUpdate = _b === void 0 ? noop : _b;
    var containerRef = useRef(null);
    var backdropRef = useRef(null);
    var contentRef = useRef(null);
    var _c = useState(false), shrinked = _c[0], setShrinked = _c[1];
    var drawerBehavior = useDrawerBehavior(containerRef, backdropRef, contentRef, open, onOpenUpdate);
    useEffect(function () {
        var isShrinked = function () {
            if (contentRef.current) {
                var _a = contentRef.current, offsetHeight = _a.offsetHeight, scrollHeight = _a.scrollHeight;
                setShrinked(scrollHeight > offsetHeight);
            }
        };
        window.addEventListener('resize', isShrinked);
        return function () {
            window.removeEventListener('resize', isShrinked);
        };
    }, [shrinked]);
    var showContent = function () { return imgSrc || children; };
    return (React.createElement(DrawerOverflow, { ref: fRef, isOpen: open },
        React.createElement(DrawerBackdrop, { ref: backdropRef, isOpen: open, onClick: drawerBehavior.onBackdropClick }),
        React.createElement(DrawerContainer, { isOpen: open, ref: containerRef },
            React.createElement(DrawerHandle, null),
            React.createElement(DrawerCard, null,
                React.createElement(DrawerCloseButton, { "aria-label": "close drawer", onClick: drawerBehavior.close, onTouchEnd: drawerBehavior.close }),
                title && React.createElement(DrawerTitle, null, title),
                showContent() && (React.createElement(DrawerContent, { ref: contentRef },
                    imgSrc && React.createElement(DrawerImage, { imgSrc: imgSrc }),
                    children && React.createElement("div", { style: { padding: '16px' } }, children))),
                showContent() && footer && shrinked && React.createElement(DrawerFooterBorder, null),
                footer && React.createElement(DrawerFooter, __assign({}, footer))))));
});
